export const slickArrowPrev = `
    <button class="slick-prev prev-button custom-prev" aria-label="Prev" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M14 2L6 10L14 18" stroke="#1C1C1C" stroke-width="1.4" stroke-linecap="round"/>
        </svg>
    </button>
`;

export const slickArrowNext = `
    <button class="slick-next next-button custom-next" aria-label="Next" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M6 18L14 10L6 2" stroke="#1C1C1C" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
    </button>
`;

export const mobileSlickArrowPrev = `
    <button class="slick-prev custom-prev prev-button" aria-label="Prev" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
            <path d="M8.05469 0.523438L0.742189 7.83594L8.05469 15.1484" stroke="#1C1C1C" stroke-width="1.05" stroke-linecap="round"/>
        </svg>
    </button>
`;

export const mobileSlickArrowNext = `
    <button class="slick-next custom-next next-button" aria-label="Next" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
            <path d="M0.523438 15.1484L7.83594 7.83594L0.523437 0.523439" stroke="#1C1C1C" stroke-width="1.05" stroke-linecap="round"/>
        </svg>
    </button>
`;
